// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"CustomInput_formGroup__BLZG4","formLabel":"CustomInput_formLabel__6mfbQ","formInput":"CustomInput_formInput__IF0S_","error":"CustomInput_error__zJD8b"};